import { render, staticRenderFns } from "./DeletePolicies.vue?vue&type=template&id=78ca838e"
import script from "./DeletePolicies.vue?vue&type=script&lang=js"
export * from "./DeletePolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports